module.exports = __webpack_public_path__ + "static/media/job_address_pin.0d63c990.svg";